import Signals from "@/signals/GameSignals";
import Facade from "@/Facade";

export default class AdapterForSlots {

    constructor(manager) {
        this.BALANCE_MULTIPLIER = 100
        this.manager = manager

        this.isInfoShown = false
        this.isPaytableShown = false
        this.isQuickspin = false

        this.init()
    }

    init() {
        this.audioValue = true

        if (Facade.urlParams)
            this.onRelaxConfigure(Facade.urlParams)
        else
            Signals.urlSettings && Signals.urlSettings.add(this.onRelaxConfigure, this)

        Signals.loadingProgress.add(this.onLoadProgress, this)
        Signals.mainGameAssetsLoadingComplete.add(this.onLoadCompleted, this)
        Signals.betChanged.add(this.onBetUpdate, this)
        Signals.betChanged.add(this.onStakeUpdate, this)
        Signals.muteClick && Signals.muteClick.add(this.onAudioToggle, this)
        Signals.startSpin && Signals.startSpin.add(this.onRoundStart, this)
        Signals.reelsStopComplete && Signals.reelsStopComplete.add(this.onRoundEnd, this)
        Signals.quitHandler && Signals.quitHandler.add(this.onClosed, this)
        Signals.balanceUpdate.add(this.onBalanceUpdate, this)
        Signals.modelInitStored && Signals.modelInitStored.add(this.onModelInitStored, this)
        Signals.setAutoplay && Signals.setAutoplay.add(this.onAutoPlayStarted, this)
        Signals.autoplayFinished && Signals.autoplayFinished.add(this.onAutoplayFinished, this)
        Signals.winsCountupComplete && Signals.winsCountupComplete.add(this.onWinUpdate, this)
        Signals.errorMessage && Signals.errorMessage.add(this.errorMessage, this)
        Signals.gameMessage && Signals.gameMessage.add(this.onReload, this)
    }

    spin() {
        Signals.spinBtnPressed && Signals.spinBtnPressed.dispatch()
    }

    setMaxBet() {
        Facade &&
        Facade.model &&
        Facade.model.setMaxBet &&
        Facade.model.setMaxBet();
    }

    // region #RECEIVED MESSAGES
    updateBalance(value) {
        if (!value) {
            value = Facade.model.balance;
        }
        Facade.model.balance = +value

        if(Signals.balanceUpdateBackend !== undefined){
            Signals.balanceUpdateBackend.dispatch(value)
        }else{
            Signals.balanceUpdate.dispatch(value)
        }
    }

    startAutoSpins(amount) {
        const data = {
            value: amount,
            singleWin: '-',
            cashIncrease: '-',
            cashDecrease: '-',
            whenEnteringFreeSpins: false,
        }

        if (Signals.setAutoplay) {
            Signals.setAutoplay.dispatch(data);
        } else {
            console.error('::: Signals.setAutoplay is not here. Check the integration adapter methods.');
        }

    }

    stopAutospins() {
        Signals.stopAutoplay && Signals.stopAutoplay.dispatch(true)
    }

    setAudio(value) {
        console.log('::: got the 1x2 audio: ', value)
        Signals.muteClick.dispatch(value)
    }

    toggleQuickspin() {
        if (!this.isQuickspin) {
            this.isQuickspin = true
            document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'quickSpin', value: this.isQuickspin}}))
        } else {
            this.isQuickspin = false
            document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'quickSpin', value: this.isQuickspin}}))
        }
        console.log(`::: QuickSpin status ${this.isQuickspin}`)
    }

    showHelp() {
        if (!this.isInfoShown) {
            this.isInfoShown = true
            document.dispatchEvent(new CustomEvent('open', {detail: {name: 'info'}}))
        } else {
            this.isInfoShown = false
            document.dispatchEvent(new CustomEvent('close', {detail: {name: 'info'}}))
        }
        console.log(`::: Help status ${this.isInfoShown}`)
    }

    togglePaytable() {
        if (!this.isPaytableShown) {
            this.isPaytableShown = true
            document.dispatchEvent(new CustomEvent('open', {detail: {name: 'paytable'}}))
        } else {
            this.isPaytableShown = false
            document.dispatchEvent(new CustomEvent('close', {detail: {name: 'paytable'}}))
        }
        console.log(`::: Help status ${this.isPaytableShown}`)
    }

    freeze() {
        this.disableAllUI()
    }

    unfreeze() {
        this.enableAll()
    }

    updateSettings(newSetting) {
        if (newSetting.sounds !== undefined) {
            this.setAudio(newSetting.sounds)
        }
    }

    quitHandler() {
        let hasToken = false
        if (Facade && Facade.hasToken)
            hasToken = Facade.hasToken()

        Signals.gameMessage && Signals.gameMessage.dispatch('terminate')
        if (Facade.model.lobbyURL && !hasToken) {
            window.location.replace(Facade.model.lobbyURL)
        }
    }

    realityCheckPopup() {
        Signals.realityCheck.dispatch()
    }

    // endregion

    // region #SEND MESSAGES
    onRelaxConfigure(data) {
        this.manager.relaxConfigure(data)
    }

    onModelInitStored() {
        Facade.model.operatorHandlesErrors = this.manager.operatorHandlesErrors
        this.onBetUpdate()
    }

    onLoadProgress(data) {
        let progress = data

        // Somewhere it's params, sometimes it's just the straight data
        if (data.params)
            progress = data.params

        this.manager.loadProgress(progress);
    }

    onLoadCompleted() {
        const audioState = this.audioValue;

        this.manager.loadCompleted();
        this.manager.audioToggle(audioState);
    }

    onAudioToggle(value) {
        this.audioValue = value
        this.manager.audioToggle(value);
    }

    onRoundStart() {
        let value = Facade.model.totalBet

        //Bonus Buy support
        if(Facade.model.isFreespinsMode){
            value = 0;
        }else if (!value) {
            value = Facade.model.totalBetNumber
        }


        // Ugly Fix in the situation when value is '$ 1.00'
        // value = "GC.100.23";
        if(typeof value === 'string' || value instanceof String){
            value = value.replace(/[^0-9\.]+/g,"");
            if(value.toString()[0] === "."){
                value = value.replace('.', '');
            }

            value = Number(value);
        }

        console.log(`::: >>> balance checking balance:[${Facade.model.balance}] bet:[${value}]`)

        if (Facade.model.balance - value > 0) {
            console.info('::: bet is allowed')
            this.manager.roundStart(this.toCents(Facade.model.balance - value))
            this.manager.winUpdate(0)
        } else {
            this.manager.insufficientFunds()
            console.info('::: bet is denied')
        }
    }

    onRoundEnd() {
        let totalBet = Facade.model.totalBet !== undefined ?
            Facade.model.totalBet :
            Facade.model.totalBetNumber;

        //Bonus Buy Support
        if(Facade.model.isFreespinsMode){
            if(Facade.model.freespins.logic.buy_freebet && Facade.model.freespins.amount_left === (Facade.model.freespins.total_amount_given - 1)){
                totalBet = Facade.model.totalBuyListBet[Facade.model.currentBetIndex];
            }else{
                totalBet = 0;
            }
        }

        // Ugly Fix in the situation when value is '$ 1.00' - Happens when totalBetNumber
        if (isNaN(totalBet.toString()[0])) {
            if (totalBet.toString()[1] === ' ')
                totalBet = totalBet.substr(2);
            else
                totalBet = totalBet.substr(1);
        }

        this.manager.roundEnd({
                balance: this.toCents(Facade.model.balance),
                totalWin: this.toCents(Facade.model.totalWin),
                totalBet: this.toCents(totalBet)
            }
        )
    }

    onAutoPlayStarted() {
        this.manager.autoPlayStarted()
    }

    onAutoplayFinished() {
        this.manager.autoplayFinished()
    }

    onBetUpdate() {
        let value = Facade.model.totalBet
        if (!value)
            value = Facade.model.totalBetNumber
        this.manager.betUpdate(this.toCents(value))
    }

    onStakeUpdate() {
        let value = Facade.model.totalBet
        if (!value)
            value = Facade.model.totalBetNumber
        this.manager.betUpdate(this.toCents(value))
    }

    onWinUpdate() {
        let value = Facade.model.totalWin
        this.manager.winUpdate(this.toCents(value))
    }

    onBalanceUpdate(value) {
        if (value === Facade.model.balance) {
            this.manager.balanceUpdate(this.toCents(value))
        }

        let totalBet = Facade.model.totalBet
        if (!totalBet)
            totalBet = Facade.model.totalBetNumber

        if (value - totalBet < 0) {
            this.manager.goToDeposit(this.toCents(value))
        }
    }

    onReload(data, force) {
        if (data === 'terminate' && (
                performance.getEntriesByType("navigation")[0].type !== "navigate")
            || force
        ) {
            this.manager.gameReload && this.manager.gameReload()
        }
    }

    onClosed() {
        if (Facade.urlParams.customer === "relax" || Facade.urlParams.customer === "betfair" || Facade.urlParams.customer === "onextwo") {
            this.manager.closed()
        } else if (!!Facade.model.lobbyURL) {
            window.open(Facade.model.lobbyURL, '_top')
        }
    }

    errorMessage(data) {
        let customer = data.customer;
        if (Facade && Facade.urlParams && Facade.urlParams.customer) {
            customer = Facade.urlParams.customer;
        }
        if (customer === 'onextwo') {
            const errObj = {
                errorMessage: data.msg || 'Connection error',
                errorCode: data.code || -1,
                errorType: data.type || 'Unknown Connection Error',
            }

            if (errObj.errorCode > 1000) {
                errObj.errorCode = -Math.abs(errObj.errorCode - 1000);
                this.manager.errorMessage(errObj);
            }
            return;
        }

        if (data.params.message === 'info_message1_text') return;
        const message = {
            errorCode: '8501',
            errorMessage: data.params.message
        };
        this.manager.errorMessage(message);
    }

    // endregion

    // region #UI
    disableAllUI() {
        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                spin: {enable: false},
                info: {enable: false},
                panelBuyButtons: {enable: false},
                coinValue: {enable: false},
                maxBet: {
                    visible: Facade.urlParams.maxBet && !Facade.model.isFreespinsMode,
                    enable: false
                },
                autoplay: {
                    visible: Facade.urlParams.autoSpin && Facade.model.autospinList.length > 0 && !Facade.model.isFreespinsMode,
                    enable: false
                }, plus: {
                    enable: false
                }, minus: {
                    enable: false
                }, settings: {
                    enable: false
                }, paytable: {
                    enable: false
                }, betHistory: {
                    enable: false
                }, menu: {
                    visible: false
                }
            }
        }))

        if (Facade.model.isFreeze) {
            if (Facade.model.isAuto) {
                Signals.stopAutoplay.dispatch()
                const detail = {
                    stopAutospin: {
                        enable: false,
                        visible: false
                    }
                }
                document.dispatchEvent(new CustomEvent("setButtonState", {detail}))
            }

            const detail = {
                spin: {visible: true, enable: false},
                stop: {visible: false, enable: false},
                stopAutospin: {enable: false, visible: false}
            }

            document.dispatchEvent(new CustomEvent("setButtonState", {detail}))
        }
    }

    enableAll() {
        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                spin: {
                    enable: true, visible: true
                }, stop: {
                    enable: false, visible: false,
                }, info: {
                    enable: true
                }, maxBet: {
                    visible: Facade.urlParams.maxBet, enable: true
                }, plus: {
                    enable: true
                }, minus: {
                    enable: true
                }, autoplay: {
                    visible: Facade.urlParams.autoSpin && Facade.model.autospinList.length > 0, enable: true
                }, autoplayCounter: {
                    enable: false, visible: false
                }, coinValue: {
                    visible: true, enable: true
                }, panelBuyButtons: {
                    enable: true
                }, settings: {
                    enable: true
                }, paytable: {
                    enable: true
                }, betHistory: {
                    enable: true
                }, menu: {
                    visible: true
                }
            }
        }))
    }

    toCents(value) {
        return Math.round(value * this.BALANCE_MULTIPLIER)
    }

    // endregion
}
